import { createAction, props } from '@ngrx/store';

export const postClaudeStructured = createAction(
  '[AI] Post Claude Structured',
  props<{ payload: any }>(),
);

export const postClaudeStructuredSuccess = createAction(
  '[AI] Post Claude Structured Success',
  props<{ response: any }>(),
);

export const postClaudeStructuredFailure = createAction(
  '[AI] Post Claude Structured Failure',
  props<{ error: string }>(),
);

export const setLoading = createAction(
  '[AI] Set Loading',
  props<{ loading: boolean }>(),
);

export const toggleAiPanel = createAction(
  '[AI] Toggle AI Panel',
  props<{ show: boolean }>(),
);

export const setAiModel = createAction(
  '[AI] Set Model',
  props<{ model: 'openai' | 'claude' }>(),
);

export const setPrompt = createAction(
  '[AI] Set Prompt',
  props<{ prompt: string }>(),
);

// Scenes
export const requestScenes = createAction(
  '[AI] Request Scenes',
  props<{ prompt: string }>(),
);
export const requestScenesSuccess = createAction(
  '[AI] Request Scenes Success',
  props<{ response: any }>(),
);
export const requestScenesFailure = createAction(
  '[AI] Request Scenes Failure',
  props<{ error: string }>(),
);

// Objects
export const requestObjects = createAction(
  '[AI] Request Objects',
  props<{ prompt: string }>(),
);
export const requestObjectsSuccess = createAction(
  '[AI] Request Objects Success',
  props<{ response: any }>(),
);
export const requestObjectsFailure = createAction(
  '[AI] Request Objects Failure',
  props<{ error: string }>(),
);

// Actions
export const requestActions = createAction(
  '[AI] Request Actions',
  props<{ prompt: string }>(),
);
export const requestActionsSuccess = createAction(
  '[AI] Request Actions Success',
  props<{ response: any }>(),
);
export const requestActionsFailure = createAction(
  '[AI] Request Actions Failure',
  props<{ error: string }>(),
);

export const setScenes = createAction(
  '[AI] Set Scenes',
  props<{ model: 'openai' | 'claude'; scenes: string[] }>(),
);

export const setObjects = createAction(
  '[AI] Set Objects',
  props<{ model: 'openai' | 'claude'; objects: string[] }>(),
);

export const setActions = createAction(
  '[AI] Set Actions',
  props<{ model: 'openai' | 'claude'; actions: string[] }>(),
);
